import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import FashionIcon from "./FashionIcon.js";
import styles from "./list_styles.css";
import { useTrack } from "@tkww/ads-content-component-analytics/react";
import getTrackingData from "../../data/index.js";
var BreadcrumbList = function BreadcrumbList(_ref) {
  var _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? [] : _ref$labels,
    _ref$caretIconName = _ref.caretIconName,
    caretIconName = _ref$caretIconName === void 0 ? "" : _ref$caretIconName,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$trackingProps = _ref.trackingProps,
    trackingProps = _ref$trackingProps === void 0 ? {} : _ref$trackingProps;
  var trackingData = getTrackingData("breadcrumbClicked");
  var _useTrack = useTrack(trackingData === null || trackingData === void 0 ? void 0 : trackingData.name, trackingData === null || trackingData === void 0 ? void 0 : trackingData.data),
    track = _useTrack.track;
  var handleClick = function handleClick(e) {
    var defaultParams = {
      selection: e.currentTarget.getAttribute("data-selection"),
      userDecisionArea: e.currentTarget.getAttribute("data-user-decision-area"),
      destinationUrl: e.currentTarget.href,
      source: window.location.pathname === '/fashion/wedding-dresses' ? 'filtered results page' : 'filtered results page',
      productType: e.currentTarget.getAttribute("product-type")
    };
    track(defaultParams);
  };
  return /*#__PURE__*/React.createElement("ol", {
    className: "".concat(styles["breadcrumb-ol"], " ").concat(className)
  }, _mapInstanceProperty(labels).call(labels, function (_ref2, index) {
    var label_text = _ref2.label_text,
      link = _ref2.link;
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, caretIconName ? /*#__PURE__*/React.createElement(FashionIcon, {
      name: caretIconName,
      size: "md",
      ariaHidden: "true"
    }) : /*#__PURE__*/React.createElement("span", {
      className: styles["slash"]
    }, "/"), link ? /*#__PURE__*/React.createElement("a", _extends({
      className: "breadcrumb-label",
      href: link
    }, trackingProps, {
      onClick: handleClick
    }), /*#__PURE__*/React.createElement("span", null, label_text)) : /*#__PURE__*/React.createElement("span", null, label_text));
  }));
};
export default BreadcrumbList;